import { FileSizeUnits } from '../backoffice/util';
import { EmporiInputType, FormDetails } from '../empracoTypes';

const texts = {
  noFiles: 'No files',
  clearTitle: 'Clear the files in this input',
  fileRequiredError: 'Please select a file as it is required'
};

function ClearFiles (element: HTMLDivElement, input: HTMLInputElement, text: Element) {
  element.innerHTML = '<i class="fa-regular fa-xmark"></i>';
  element.title = texts.clearTitle;
  element.onclick = () => {
    input.value = '';
    element.innerHTML = '';
    text.innerHTML = texts.noFiles;
  };
}

// TODO: Comment this file and clean it up.
export function FormSelectorFns (formDetails: FormDetails) {
  const showFileErrorMessage = (showError: boolean, target: HTMLInputElement, message: string|null) => {
    const inputDesc = target.closest('div.node-file')?.querySelector<HTMLInputElement>('p.input-desc');
    if(inputDesc != null) {
      inputDesc.hidden = showError;
    }

    const errorDesc = target.closest('div.node-file')?.querySelector<HTMLElement>('p.error-desc');
    if(errorDesc != null) {
      if (message != null) {
        errorDesc.innerHTML = message;
      }
      errorDesc.hidden = !showError;
    }

    if (showError) {
      target.closest('div.file-input-container')?.classList.add('error-file');
    } else {
      target.closest('div.file-input-container')?.classList.remove('error-file');
    }
  };

  if (!formDetails.formId) {
    return;
  }

  const fileInputs = document.getElementById(formDetails.formId)?.querySelectorAll('input[type=file]');
  const fileTypes = formDetails.form.settings.allowedFileTypes;

  const formLimit = formDetails.form.settings.maxUploadFileSize;
  const globalLimit = formDetails.globalMaxUploadFileSize;

  // Calculates in megabytes
  const getFileSizeLimit = () => {

    if (formLimit && formLimit > 0) {
      return formLimit * FileSizeUnits.MiB;
    }

    if (globalLimit && globalLimit > 0) {
      return globalLimit * FileSizeUnits.MiB;
    }

    return 0;
  };

  const fileSizeLimit = getFileSizeLimit();

  if (fileInputs && fileInputs.length > 0) {
    fileInputs.forEach(input => {
      input.addEventListener('change', event  => {

        const target = event.currentTarget as HTMLInputElement;
        if (target == null || target.value == null || target.value === '') {
          return;
        }

        const files = target.files;
        if (!files) {
          return;
        }

        const fileSize = files
          ? Array.from(files).reduce((prev, num) => { return prev + num.size; }, 0)
          : 0;

        const textEl = target.nextElementSibling?.querySelector('.upload-status');
        const fileExtensionArr = files![0].name.split('.');
        const fileExtension = '.' + fileExtensionArr[fileExtensionArr.length - 1];
        const clearEl = input.parentElement?.nextElementSibling as HTMLDivElement;

        const verifyFileType = () => {
          if (!fileTypes) {
            return true; // Allow all types
          }

          const type = files[0].type;
          return fileTypes.filter(s => s && s.type === type || s.type === fileExtension).length > 0;
        };

        const reset = () => {
          target.files = null;
          target.value = '';
          if (textEl) {
            textEl.innerHTML = texts.noFiles;
          }
        };

        const fileSizeAllowed = fileSizeLimit === 0 || fileSize <= fileSizeLimit;
        const fileTypesAllowed = verifyFileType();

        // File size validation error.
        if (textEl && files && !fileSizeAllowed) {
          reset();

          const mbValue = formLimit && formLimit > 0
            ? formLimit
            : globalLimit && globalLimit > 0
              ? globalLimit : 0;

          // eslint-disable-next-line max-len
          const errorMessage = `File size exceeded maximum allowed upload file size of ${mbValue} MB. Please upload less or smaller files.`;
          showFileErrorMessage(true, target, errorMessage);
          return;
        }

        // File type validation error.
        if (textEl && files && !fileTypesAllowed) {
          reset();
          const allowedTypes = fileTypes.map(m => m.type).join(', ');
          const errorMessage = `Only supports ${allowedTypes} file ${fileTypes.length > 1 ? 'formats' : 'format'}.`;
          showFileErrorMessage(true, target, errorMessage);
        }

        // File upload succeeded.
        if (textEl && clearEl && fileTypesAllowed && fileSizeAllowed) {
          showFileErrorMessage(false, target, null);
          let filesText = files.length > 1 ? `${files.length} files` : files[0].name;
          textEl.innerHTML = filesText;
          ClearFiles(clearEl, target, textEl);
          return;
        }
      });
    });
  };

  let formSubmitBtn = document.getElementById(formDetails.formSubmitButtonId);

  if (formSubmitBtn) {
    formSubmitBtn.addEventListener('click', async event => {
      let validationFailed = false;
      const form = document.getElementById(formDetails.formId) as HTMLFormElement;

      if (form == null) {
        return;
      }

      const requiredFields = formDetails.form.inputs
        .filter(s => (s.type === EmporiInputType.checkbox ||
          s.type === EmporiInputType.file ||
          s.type === EmporiInputType.radiobutton) && s.required);

      requiredFields.forEach(field => {
        if (field.type === EmporiInputType.checkbox || field.type === EmporiInputType.radiobutton) {
          const fieldId = 'input[id*="' + field.uniqueName + '"]';
          const inputFields = form.querySelectorAll<HTMLInputElement>(fieldId);

          let checked = false;
          for(let i=0; i < inputFields.length; i++) {
            if (inputFields[i] != null) {
              inputFields[i].addEventListener('click', e => {
                const targetClick = e .currentTarget as HTMLInputElement;
                if (targetClick.checked) {
                  let element = inputFields[0].closest('div.form-node')?.querySelector<HTMLElement>('p.error-desc');
                  if (element != null) {
                    element.style.display = 'none';
                  }
                }
              });

              if (inputFields[i].checked) {
                checked = true;
                break;
              }
            }
          }

          if (!checked) {
            let element = inputFields[0].closest('div.form-node')?.querySelector<HTMLElement>('p.error-desc');
            if (element != null) {
              element.style.display = 'block';
            }
            validationFailed = true;
          }
        }

        if (field.type === EmporiInputType.file) {
          const fileInputId = 'input[id*="' + field.uniqueName + '"]';
          const fileField = form.querySelector<HTMLInputElement>(fileInputId);

          if (fileField == null || fileField.files == null) {
            return;
          }

          if (fileField.files!.length <= 0) {
            showFileErrorMessage(true, fileField, texts.fileRequiredError);
            validationFailed = true;
          }
        }
      });

      if (!form.checkValidity() || validationFailed) {
        form.reportValidity();
        return;
      }

      if (formDetails.stayOnPage) {
        event.preventDefault();
        const messageEl = document.getElementById(formDetails.messageKey);
        const statusEl = document.getElementById(formDetails.statusKey);

        if (statusEl) {
          statusEl.style.display = 'block';
          statusEl.innerHTML = '<i class="fa-regular fa-spinner fa-spin"></i><span>Skickar formulärsdata...</span>';
        }

        await fetch(formDetails.fetchUrl, {
          method: 'POST',
          body: new FormData(form)
        }).then(res => {
          if (res.ok) {
            form.style.display = 'none';
            if (messageEl) {
              messageEl.style.display = 'block';
            }
            if (statusEl) {
              statusEl.style.display = 'none';
            }
          }
        }).catch(err => {
          if (statusEl) {
            statusEl.innerHTML = `<pre>${err}</pre>`;
          }
        });
      } else {
        form.submit();
      }
    });
  }
}